import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button } from '@blueprint/ui';
import { FormFooter } from "../../../common/components/form";

import PublicFormContainer from "../components/PublicFormContainer";
import { publicUserAPI } from "../../../api/publicUser";
import useLogoutWithoutRedirect from "../hooks/useLogoutWithoutRedirect";


type ForgotOTPFormProps = {
    email: string;
};
const ForgotOTPForm = ({
    email,
}: ForgotOTPFormProps): JSX.Element => {
    const history = useHistory();

    const logout = useLogoutWithoutRedirect();

    useEffect(() => {
        try {
            publicUserAPI.forgotOTP(email);
            logout();
        } catch (err) {
            console.error(err);
        }
    }, [logout, email]);

    return (
        <PublicFormContainer>
            <h2 className="mb-4">Email has been sent</h2>
            <p className="mb-5">
                You will receive a reset 2 Factor Authentication link in your registered email.
            </p>
            <p className="mb-5">
                Please check your email inbox for further instructions.
            </p>
            <FormFooter className="d-flex mb-5">
                <Button
                    onClick={()=> history.push("/")}
                    type="submit"
                    className="btn btn-primary flex-grow-1"
                    variant="light.primary">Back To Login</Button>
            </FormFooter>
        </PublicFormContainer>
    );
};

export default ForgotOTPForm;
